<template lang="pug">
  v-row(justify="center" align="end") 
    v-col(cols=12 md=3).pb-0
      selection-status(
        v-model="searchParams['is_game_pending']"
      )
    v-col(cols=12 md=3).pb-0
      selection-date-time(
        v-model="searchParams['start_date']"
        :label="$t('start-date')"
        :max="searchParams['end_date']"
      )
    v-col(cols=12 md=3).pb-0
      selection-date-time(
        v-model="searchParams['end_date']"
        :label="$t('end-date')"
        :min="searchParams['start_date']"
      )
    v-col(align="end").pb-0
      n2-btn(
        style="height:35px;"
        :block="false"
        @click="load"
      )
        | {{ $t('search') }}
        v-icon mdi-magnify
    v-col(cols=12).px-5
      v-data-table(
        disable-sort
        :items="items"
        :headers="headers"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItem"
        :footer-props="footerProps"
        mobile-breakpoint="1040"
      ) 
        template(#no-data)
          h3 {{ $t('no-content') }}

        template(#item.power_play="{ value }")
          v-icon(v-if="value" color="green") mdi-check 
          v-icon(v-else color="red") mdi-close 

        template(#item.created_at="{ value }")
          | {{ value | date }}
        template(#item.price="{ value }")
          | {{ value | number_comma }}
        template(#item.reward="{ value }")
          | {{ value | number_comma }}
        template(#item.status.name="{ item, value }")
          h4(:class="classStatus(item)") {{ value }}
        template(#item.win_number.power_play="{ value }")
          div(v-if="value") x {{ value }}
        template(#item.number="{ item }") 
          v-row(justify="center")
            v-col(cols="auto")
              winnumber(
                small
                :win-number-array="[...item.white_ball, item.power_ball]" 
              )
        template(#item.win-number="{ item }")
          v-row(v-if="item.win_number" justify="center")
            v-col(cols="auto")
              winnumber(
                small
                :win-number-array="[...item.win_number.white_ball, item.win_number.power_ball]" 
              )
</template>
<script>
import { powerBall as apiPowerball } from '@/apis'
import winnumber from './Winnumber.vue'
import SelectionStatus from '../components/Selection/SelectionStatus.vue'
import SelectionDateTime from '../components/Selection/SelectionDateTime.vue'
import { 
  // datePreviousOneWeekDate, 
  convertDateToISO 
} from '@/plugins/time'

const CurDate = convertDateToISO(new Date())
// const PreviosWeekDate = datePreviousOneWeekDate(new Date())


export default {
  components: {
    winnumber,
    SelectionStatus,
    SelectionDateTime
  },
  data: () => ({
    searchParams: {
      start_date: CurDate,
      end_date: CurDate,
      is_game_pending: 1
    },
    loading:false,
    items: [],
    options: {
      page:1,
      itemsPerPage:15,
    },
    totalItem: -1,
    meta: {},
  }),
  computed: {
    footerProps () {
      return {
        "items-per-page-text": this.$t('row-per-page'),
        "disable-items-per-page": true,
        "show-current-page": true
      }
    },
    headers () {
      return [
      { text: this.$t('date'), value: 'created_at', align: 'center' },
      { text: this.$t('power-ball.number'), value: 'number', align: 'center' },
      { text: 'Power play', value: 'power_play', align: 'center' },
      { text: this.$t('price'), value: 'price', align: 'center' },
      { text: this.$t('status'), value: 'status.name', align: 'center' },
      { text: this.$t('power-ball.win-amount'), value: 'reward', align: 'center' },
      { text: this.$t('power-ball.winnumber'), value: 'win-number', align: 'center' },
      { text: this.$t('power-ball.power-play-winnumber'), value: 'win_number.power_play', align: 'center' },
    ]
  }
  },
  watch: {
    options (val) {
      if(!this.options.page) return
      if(this.meta['current_page'] === this.options.page 
      && this.meta['item_per_page'] === this.options.itemsPerPage) {
        return
      }
      //map options from table to params 
      const params = {
        page: val.page,
        'item_per_page': val.itemsPerPage
      }
      this.load(params)
    }
  },
  methods: {
    classStatus (item) {
      const id = (item.status || {}).id
      if(id === 4){
        return 'red--text'
      } else if(id === 3) {
        return 'green--text' 
      } else {
        return 'blue--text' 
      }
    },
    mapSearchParams () {
      const { is_game_pending, start_date, end_date } = this.searchParams
      const params = {
        is_game_pending,
        start_date: `${start_date} 00:00:00`,
        end_date: `${end_date} 23:59:59`,
      }
      return params
    },
    async load (params={}) {
      const searchParams = this.mapSearchParams()
      params = Object.assign({}, searchParams, params)
      this.loading = true
      const [err, data,, meta] = await apiPowerball.getStakes(params)
      this.loading = false
      if(err) return
      this.items = data
      this.meta = meta
      this.options = {
        page: meta['current_page'],
        itemsPerPage: meta['item_per_page']
      }
      this.totalItem = meta['total_item_current_page']
    }
  }
}
</script>